// extracted by mini-css-extract-plugin
export default {"container":"xnVnIvXq","image":"A2Qoi_9V","skeleton":"IB_YvNmG","staticBackground":"Ah6MzpMJ"};